import React from 'react'
import { radius, ThemeMode } from './tokens'
import { useTheme } from './ThemeProvider'

/**
 * 主题三态开关 —— 「跟随 / 宣纸 / 夜墨」
 *
 * 三态而非两态的取舍：只做明暗两态的话，"想跟随系统"的用户就没法表达，
 * 一旦点过开关就被永久钉死在某一态。所以第一段必须是「跟随」。
 *
 * 用 aria-pressed 表达选中（与设计稿的 .theme-switch 一致），不用 radio ——
 * 这是"切换视图"而不是表单选择，读屏下 pressed 语义更贴切。
 */

const OPTIONS: {mode: ThemeMode, label: string, title: string}[] = [
	{mode: 'system', label: '跟随', title: '跟随系统深浅色'},
	{mode: 'light', label: '宣纸', title: '浅色 · 宣纸'},
	{mode: 'dark', label: '夜墨', title: '深色 · 夜墨'},
]

const wrapStyle: React.CSSProperties = {
	display: 'inline-flex',
	gap: 2,
	padding: 3,
	borderRadius: radius.md,
	border: '1px solid var(--line)',
	background: 'var(--paper-2)',
	flex: 'none',
}

const btnBase: React.CSSProperties = {
	font: 'inherit',
	fontSize: 12,
	padding: '3px 10px',
	border: 0,
	borderRadius: 2,
	background: 'none',
	color: 'var(--ink-2)',
	cursor: 'pointer',
	whiteSpace: 'nowrap',
}

export function ThemeSwitch() {
	const {mode, setMode} = useTheme()
	return <div style={wrapStyle} role="group" aria-label="主题">
		{OPTIONS.map(opt => <button
			key={opt.mode}
			type="button"
			title={opt.title}
			aria-pressed={mode === opt.mode}
			onClick={() => setMode(opt.mode)}
			style={mode === opt.mode
				// 选中态走青瓷淡底 —— 与顶栏其它激活态同一套语言
				? {...btnBase, background: 'var(--celadon-2)', color: 'var(--celadon-ink)', fontWeight: 500}
				: btnBase}
		>{opt.label}</button>)}
	</div>
}
